import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextEditFeaturePlan,
    onClose: _ctx.close,
    onSubmit: _ctx.submit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "planForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "Password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Password = $event)),
                placeholder: _ctx.$wordList.TabelPersonUserInHtmlPassword,
                type: "password"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onClose", "onSubmit"]))
}